exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3526f172] .el-pager li{min-width:25.5px;padding:0}.el-pagination[data-v-3526f172]{padding-left:0}[data-v-3526f172] button,[data-v-3526f172] span:not([class*=suffix]){min-width:25.5px}[data-v-3526f172] .btn-next{padding-left:0;padding-right:0}[data-v-3526f172] .btn-next .el-icon{display:inline-block}[data-v-3526f172] .btn-prev{padding-left:0;padding-right:0}[data-v-3526f172] .btn-prev .el-icon{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3526f172","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Pagination/index.vue
// module id = 267
// module chunks = 0